import { createReducer, on } from '@ngrx/store';
import { Account } from '@smmof/entity';
import { AccountActions } from '../actions/account.actions';
import { SignInResPayloadDto } from '@smmof/dto';

export interface AccountState {
  isAuthenticated: boolean;
  token: SignInResPayloadDto | null;
  account: Account | null;
}

export const initialState: AccountState = {
  isAuthenticated: false,
  token: null,
  account: null,
};

export const accountReducer = createReducer(
  initialState,
  /** Устанавливаем данные аккаунта */
  on(AccountActions.setAccountData, (state, { account }) => ({
    ...state,
    account: account,
  })),
  on(AccountActions.setAccountAuth, (state, { token }) => ({
    ...state,
    token: token ?? null,
    isAuthenticated: !!token,
  })),
  /** Успешно получили данные аккаунта */
  on(AccountActions.getAccountDataSuccess, (state, { account }) => ({
    ...state,
    account: account,
  })),
  /** Не удалось получить данные аккаунта */
  on(AccountActions.getAccountDataFailure, (state) => ({
    ...state,
    account: null,
  })),
  on(AccountActions.clearAccountData, () => initialState),
);
